/**
 * Base icon registry - contains icons shared across all customers
 * These icons are available to all customers and serve as fallbacks
 */

import Collapse from '../assets/icons/actions/collapse.svg'
import Delete from '../assets/icons/actions/delete.svg'
import DeleteRound from '../assets/icons/actions/delete-round.svg'
import Expand from '../assets/icons/actions/expand.svg'
import AddPhoto from '../assets/icons/add-photo.svg'
import AddImages from '../assets/icons/add-pictures.svg'
import AddUser from '../assets/icons/add-user.svg'
import AircraftTable from '../assets/icons/aircraft-table.svg'
import AirportGate from '../assets/icons/airport-gate.svg'
import Arrow from '../assets/icons/arrow.svg'
import ArrowDownward from '../assets/icons/arrow-downward.svg'
import ArrowHead from '../assets/icons/arrow-head.svg'
import ArrowRightBig from '../assets/icons/arrow-right-big.svg'
import ArrowRightThin from '../assets/icons/arrow-right-thin.svg'
import ArrowUpward from '../assets/icons/arrow-upward.svg'
import Asset from '../assets/icons/asset.svg'
import Assignment from '../assets/icons/assignment.svg'
import AssignmentStar from '../assets/icons/assignment-star.svg'
import Atc from '../assets/icons/atc.svg'
import ATCTower from '../assets/icons/atc-air-traffic-control-tower.svg'
import Attachment from '../assets/icons/attachment.svg'
import AutomaticFeed from '../assets/icons/automatic-feed.svg'
import Back from '../assets/icons/back.svg'
import Bag from '../assets/icons/bag.svg'
import Billable from '../assets/icons/billable.svg'
import Burger from '../assets/icons/burger.svg'
import Camera from '../assets/icons/camera.svg'
import ChannelMail from '../assets/icons/channels/channel-mail.svg'
import ChannelNotification from '../assets/icons/channels/channel-notification.svg'
import ChannelPush from '../assets/icons/channels/channel-push.svg'
import ChannelSms from '../assets/icons/channels/channel-sms.svg'
import CheckCircle from '../assets/icons/check-circle.svg'
import CheckCircleFilled from '../assets/icons/check-circle-filled.svg'
import Check from '../assets/icons/check-white.svg'
import CheckboxIndeterminateDark from '../assets/icons/checkbox/checkbox.svg'
import CheckboxChecked from '../assets/icons/checkbox/checkbox-checked.svg'
import CheckboxCheckedLight from '../assets/icons/checkbox/checkbox-checked-light.svg'
import CheckboxDone from '../assets/icons/checkbox/checkbox-done.svg'
import CheckboxEmpty from '../assets/icons/checkbox/checkbox-empty.svg'
import CheckboxEmptyDisabled from '../assets/icons/checkbox/checkbox-empty-disabled.svg'
import CheckboxGreenDone from '../assets/icons/checkbox/checkbox-green-done.svg'
import CheckboxIndeterminate from '../assets/icons/checkbox/checkbox-indeterminate.svg'
import CheckboxWhite from '../assets/icons/checkbox/checkbox-white.svg'
import Checklist from '../assets/icons/checklist.svg'
import ChecklistItem from '../assets/icons/checklist-item.svg'
import Chevron from '../assets/icons/chevron.svg'
import ChevronRight from '../assets/icons/chevron-right.svg'
import Close from '../assets/icons/close.svg'
import CloseEvent from '../assets/icons/close-event.svg'
import Compass from '../assets/icons/compass.svg'
import ConditionalIndicator from '../assets/icons/conditional-indicator.svg'
import ConfigureNotifications from '../assets/icons/configure-notifications.svg'
import ContactList from '../assets/icons/Contacts.svg'
import Content from '../assets/icons/content.svg'
import Copy from '../assets/icons/copy.svg'
import CreateTask from '../assets/icons/create-task.svg'
import CurrentTime from '../assets/icons/current-time.svg'
import CUSSParkingMeters from '../assets/icons/cuss-parking-meters.svg'
import DangerousGoods from '../assets/icons/dangerous-goods.svg'
import Dashboard from '../assets/icons/dashboard.svg'
import Datapicker from '../assets/icons/datapicker.svg'
import Default from '../assets/icons/default.svg'
import Delay from '../assets/icons/delay.svg'
import Departures from '../assets/icons/departures.svg'
import Description from '../assets/icons/description.svg'
import DismissNotification from '../assets/icons/dismiss-notification.svg'
import Done from '../assets/icons/done.svg'
import Download from '../assets/icons/download.svg'
import DraggingHandle from '../assets/icons/dragging-handle.svg'
import Drop from '../assets/icons/drop.svg'
import Edit from '../assets/icons/edit.svg'
import Emergency from '../assets/icons/emergency.svg'
import Events from '../assets/icons/events.svg'
import ExportChecklistTemplates from '../assets/icons/export-checklist-templates.svg'
import FatArrowRight from '../assets/icons/fat-arrow-right.svg'
import FeedOutConfirmation from '../assets/icons/feed-out-confirmation.svg'
import Filter from '../assets/icons/filter.svg'
import Firefighters from '../assets/icons/firefighters.svg'
import FlagDay from '../assets/icons/flag-day.svg'
import FlightChecks from '../assets/icons/flight-checks.svg'
import FlightInfo from '../assets/icons/flight-info.svg'
import Flights from '../assets/icons/flights.svg'
import Fold from '../assets/icons/fold.svg'
import Forward from '../assets/icons/forward.svg'
import ForwardFat from '../assets/icons/forward-fat.svg'
import Fuel from '../assets/icons/fuel.svg'
import Fullscreen from '../assets/icons/FullScreen.svg'
import Gas from '../assets/icons/gas.svg'
import GatePark from '../assets/icons/gate-park.svg'
import Geolocation from '../assets/icons/geolocation.svg'
import Green from '../assets/icons/green.svg'
import Grey from '../assets/icons/grey.svg'
import Handling from '../assets/icons/handling.svg'
import HeatingWires from '../assets/icons/heating-wires.svg'
import Help from '../assets/icons/help.svg'
import Hourglass from '../assets/icons/hourglass.svg'
import Images from '../assets/icons/images-big.svg'
import InfoCircle from '../assets/icons/info-circle.svg'
import Invalid from '../assets/icons/invalid.svg'
import Invitation from '../assets/icons/invitation.svg'
import Layers from '../assets/icons/layers.svg'
import Location from '../assets/icons/location.svg'
import LocationUnderline from '../assets/icons/location-underline.svg'
import LogOut from '../assets/icons/log-out.svg'
import Mail from '../assets/icons/mail.svg'
import Map from '../assets/icons/map.svg'
import TrainDirection from '../assets/icons/map-items/train-direction.svg'
import TrainInner from '../assets/icons/map-items/train-inner.svg'
import TrainNoDirection from '../assets/icons/map-items/train-no-direction.svg'
import TrainNumber from '../assets/icons/map-items/train-number.svg'
import MarkReview from '../assets/icons/mark-review.svg'
import Message from '../assets/icons/message.svg'
import MessageTriangle from '../assets/icons/message-triangle.svg'
import Messaging from '../assets/icons/messaging.svg'
import More from '../assets/icons/more.svg'
import MoreInfo from '../assets/icons/more-info.svg'
import NoData from '../assets/icons/no-data.svg'
import NoForecast from '../assets/icons/no-forecast.svg'
import NoPhotos from '../assets/icons/no-photos.svg'
import NotAllowed from '../assets/icons/not-allowed.svg'
import NOTAM from '../assets/icons/NOTAM.svg'
import Note from '../assets/icons/note.svg'
import Notifications from '../assets/icons/notifications.svg'
import NotificationsEmpty from '../assets/icons/notifications-empty.svg'
import Notify from '../assets/icons/notify-big.svg'
import OkSmall from '../assets/icons/ok-small.svg'
import OpenIn from '../assets/icons/open-in.svg'
import OperationalForecastAirside from '../assets/icons/operational-forecast/operational-forecast-airside.svg'
import OperationalForecastBags from '../assets/icons/operational-forecast/operational-forecast-bags.svg'
import OperationalForecastNetwork from '../assets/icons/operational-forecast/operational-forecast-network.svg'
import OperationalForecastPassengers from '../assets/icons/operational-forecast/operational-forecast-passengers.svg'
import OperationalForecastTerminal from '../assets/icons/operational-forecast/operational-forecast-terminal.svg'
import OperationalForecastTurnaround from '../assets/icons/operational-forecast/operational-forecast-turnaround.svg'
import Orange from '../assets/icons/orange.svg'
import OtherRed from '../assets/icons/other-red.svg'
import OutdatedApp from '../assets/icons/outdated-app.svg'
import Park from '../assets/icons/park.svg'
import ParticipantAtAirport from '../assets/icons/participant-at-airport.svg'
import ParticipantComing from '../assets/icons/participant-coming.svg'
import ParticipantCommand from '../assets/icons/participant-incident-command.svg'
import ParticipantLeft from '../assets/icons/participant-left.svg'
import ParticipantObserving from '../assets/icons/participant-observe.svg'
import ParticipantPending from '../assets/icons/participant-pending.svg'
import ParticipantRemote from '../assets/icons/participant-remote.svg'
import Pause from '../assets/icons/pause-filled.svg'
import Pax from '../assets/icons/pax.svg'
import Percent from '../assets/icons/percent.svg'
import Phone from '../assets/icons/phone.svg'
import PickLocation from '../assets/icons/pick-location.svg'
import ParkingCarReturn from '../assets/icons/pictograms/parking/parking_CarReturn.svg'
import ParkingP from '../assets/icons/pictograms/parking/parking_P.svg'
import ParkingP1 from '../assets/icons/pictograms/parking/parking_P1.svg'
import ParkingP2 from '../assets/icons/pictograms/parking/parking_P2.svg'
import ParkingP3 from '../assets/icons/pictograms/parking/parking_P3.svg'
import ParkingP3Pika from '../assets/icons/pictograms/parking/parking_P3_Pika.svg'
import ParkingP3Premium from '../assets/icons/pictograms/parking/parking_P3-Premium.svg'
import ParkingP4A from '../assets/icons/pictograms/parking/parking_P4A.svg'
import ParkingP4B from '../assets/icons/pictograms/parking/parking_P4B.svg'
import ParkingP5 from '../assets/icons/pictograms/parking/parking_P5.svg'
import ParkingP6 from '../assets/icons/pictograms/parking/parking_P6.svg'
import ParkingP8 from '../assets/icons/pictograms/parking/parking_P8.svg'
import TravelServicesArrivalServices from '../assets/icons/pictograms/travelServices/travelServices_arrivalServices.svg'
import TravelServicesBaggageClaim1 from '../assets/icons/pictograms/travelServices/travelServices_baggageClaim1.svg'
import TravelServicesBaggageClaim2A from '../assets/icons/pictograms/travelServices/travelServices_baggageClaim2A.svg'
import TravelServicesBaggageClaim2B from '../assets/icons/pictograms/travelServices/travelServices_baggageClaim2B.svg'
import TravelServicesCheckInDesks101114 from '../assets/icons/pictograms/travelServices/travelServices_checkInDesks101114.svg'
import TravelServicesCheckInDesks201218 from '../assets/icons/pictograms/travelServices/travelServices_checkInDesks201218.svg'
import TravelServicesCheckInDesks219232 from '../assets/icons/pictograms/travelServices/travelServices_checkInDesks219232.svg'
import TravelServicesCheckInDesks240270 from '../assets/icons/pictograms/travelServices/travelServices_checkInDesks240270.svg'
import TravelServicesCheckInKiosk from '../assets/icons/pictograms/travelServices/travelServices_checkInKiosk.svg'
import TravelServicesCustoms from '../assets/icons/pictograms/travelServices/travelServices_customs.svg'
import TravelServicesPassportControl from '../assets/icons/pictograms/travelServices/travelServices_passportControl.svg'
import TravelServicesSecurityCheck from '../assets/icons/pictograms/travelServices/travelServices_securityCheck.svg'
import WalkingRouteMarker from '../assets/icons/pictograms/walking-route-marker.svg'
import Pictures from '../assets/icons/pictures.svg'
import Pin from '../assets/icons/pin.svg'
import Pinned from '../assets/icons/pinned.svg'
import Place from '../assets/icons/place.svg'
import ArrivalsPlaceholder from '../assets/icons/placeholders/arrivals-placeholder.svg'
import ChecklistPlaceholder from '../assets/icons/placeholders/checklist-placeholder.svg'
import CreateMessageTemplatePlaceholder from '../assets/icons/placeholders/create-message-template-placeholder.svg'
import CreateTaskPlaceholder from '../assets/icons/placeholders/create-task-placeholder.svg'
import DeparturesPlaceholder from '../assets/icons/placeholders/departures-placeholder.svg'
import EmptyList from '../assets/icons/placeholders/empty-list.svg'
import InspectorPlaceholder from '../assets/icons/placeholders/inspector-placeholder.svg'
import InvitePlaceholder from '../assets/icons/placeholders/invite-placeholder.svg'
import MessagePlaceholder from '../assets/icons/placeholders/message-placeholder.svg'
import MessageTemplatePlaceholder from '../assets/icons/placeholders/message-template-placeholder.svg'
import NoEvents from '../assets/icons/placeholders/no-events.svg'
import NoMessages from '../assets/icons/placeholders/no-messages.svg'
import NoTasks from '../assets/icons/placeholders/no-tasks.svg'
import PrivateInvitation from '../assets/icons/placeholders/private-invitation.svg'
import UnitPlaceholder from '../assets/icons/placeholders/unit-placeholder.svg'
import UserGroupPlaceholder from '../assets/icons/placeholders/user-group-placeholder.svg'
import UserPlaceholder from '../assets/icons/placeholders/user-placeholder.svg'
import Plane from '../assets/icons/plane.svg'
import PlaneStanding from '../assets/icons/plane-standing.svg'
import Play from '../assets/icons/play-filled.svg'
import Plus from '../assets/icons/plus.svg'
import Policy from '../assets/icons/policy.svg'
import Private from '../assets/icons/private.svg'
import PrivateClosed from '../assets/icons/private-closed.svg'
import RadioChecked from '../assets/icons/radio-checked.svg'
import RadioCheckedDisabled from '../assets/icons/radio-checked-disabled.svg'
import RadioEmpty from '../assets/icons/radio-empty.svg'
import RadioEmptyDisabled from '../assets/icons/radio-empty-disabled.svg'
import Recent from '../assets/icons/recent.svg'
import Red from '../assets/icons/red.svg'
import Report from '../assets/icons/report.svg'
import RestoreUser from '../assets/icons/restore-user.svg'
import RotateLeft from '../assets/icons/rotate-left.svg'
import RotateRight from '../assets/icons/rotate-right.svg'
import Route from '../assets/icons/route.svg'
import Save from '../assets/icons/save.svg'
import AircraftStands from '../assets/icons/scenarios/aircraft-stands.svg'
import AirlineGroundHandling from '../assets/icons/scenarios/airline-ground-handling.svg'
import Arrivals from '../assets/icons/scenarios/arrivals.svg'
import Gate from '../assets/icons/scenarios/gate.svg'
import Info from '../assets/icons/scenarios/info.svg'
import InfoManagement from '../assets/icons/scenarios/info-management.svg'
import Lightning from '../assets/icons/scenarios/lightning.svg'
import NetworkGeneral from '../assets/icons/scenarios/network-general.svg'
import NetworkIt from '../assets/icons/scenarios/network-it.svg'
import NetworkWeather from '../assets/icons/scenarios/network-weather.svg'
import NetworkWorld from '../assets/icons/scenarios/network-world.svg'
import Roads from '../assets/icons/scenarios/roads.svg'
import SafetySecurity from '../assets/icons/scenarios/safety-security.svg'
import Snow from '../assets/icons/scenarios/snow.svg'
import Train from '../assets/icons/scenarios/train.svg'
import TurnaroundGeneralInfo from '../assets/icons/scenarios/turnaround-general-info.svg'
import World from '../assets/icons/scenarios/world.svg'
import Schedule from '../assets/icons/schedule.svg'
import SearchFilters from '../assets/icons/search-filters.svg'
import Search from '../assets/icons/search-white.svg'
import SelectItem from '../assets/icons/select-item.svg'
import Send from '../assets/icons/send.svg'
import SendAlert from '../assets/icons/send-alert.svg'
import Settings from '../assets/icons/settings.svg'
import Share from '../assets/icons/share.svg'
import ShiftNote from '../assets/icons/shift_note.svg'
import ShowLess from '../assets/icons/show-less.svg'
import ShowMore from '../assets/icons/show-more.svg'
import SNOWTAM from '../assets/icons/SNOWTAM.svg'
import Sorting from '../assets/icons/sorting.svg'
import Source from '../assets/icons/source.svg'
import Spinner from '../assets/icons/spinner.svg'
import Star from '../assets/icons/star.svg'
import Error from '../assets/icons/status/error.svg'
import Success from '../assets/icons/status/success.svg'
import Warning from '../assets/icons/status/warning.svg'
import WarningBold from '../assets/icons/status/warning-bold.svg'
import StatusAtAirport from '../assets/icons/status-at-airport.svg'
import StatusComing from '../assets/icons/status-coming.svg'
import StatusRemote from '../assets/icons/status-remote.svg'
import StatusReport from '../assets/icons/status-report-big.svg'
import Storage from '../assets/icons/storage-big.svg'
import Subscriptions from '../assets/icons/subscriptions.svg'
import Target from '../assets/icons/target.svg'
import Task from '../assets/icons/task.svg'
// Import shared scenario icons from aos-ui-common
// Import base icons from aos-ui
import Car from '../assets/icons/tasks/car.svg'
import Chemicals from '../assets/icons/tasks/chemicals.svg'
import Contractors from '../assets/icons/tasks/contractors.svg'
// Import task icons from aos-ui-common
import EquipmentMaintenance from '../assets/icons/tasks/EquipmentMaintenance.svg'
import Fireman from '../assets/icons/tasks/fireman.svg'
import Jobs from '../assets/icons/tasks/jobs.svg'
import LoadReception from '../assets/icons/tasks/LoadReception.svg'
import TaskOther from '../assets/icons/tasks/Other.svg'
import Refuelling from '../assets/icons/tasks/Refuelling.svg'
import RegularInspection from '../assets/icons/tasks/RegularInsp.svg'
import Road from '../assets/icons/tasks/road.svg'
import TakingSamples from '../assets/icons/tasks/Sample.svg'
import Square from '../assets/icons/tasks/square.svg'
import Supervision from '../assets/icons/tasks/Supervision.svg'
import TaskAnimalBanishment from '../assets/icons/tasks/task-animal-banishment.svg'
import TaskAnimalConfirmation from '../assets/icons/tasks/task-animal-confirmation.svg'
import TaskAnimalKill from '../assets/icons/tasks/task-animal-kill.svg'
import TaskAnimalObservation from '../assets/icons/tasks/task-animal-observation.svg'
import TaskAnimals from '../assets/icons/tasks/task-animals.svg'
import TaskDeicing from '../assets/icons/tasks/task-deicing.svg'
import TaskHba from '../assets/icons/tasks/task-hba.svg'
import TaskInspectionAreaInspection from '../assets/icons/tasks/task-inspection-area-inspection.svg'
import TaskInspectionContractor from '../assets/icons/tasks/task-inspection-contractor.svg'
import TaskInspectionFireTruck from '../assets/icons/tasks/task-inspection-fire-truck.svg'
import TaskInspectionFod from '../assets/icons/tasks/task-inspection-fod.svg'
import TaskInspectionOther from '../assets/icons/tasks/task-inspection-other.svg'
import TaskInspectionOtherActors from '../assets/icons/tasks/task-inspection-other-actors.svg'
import TaskInspectionOtherAreas from '../assets/icons/tasks/task-inspection-other-areas.svg'
import TaskInspectionRope from '../assets/icons/tasks/task-inspection-rope.svg'
import TaskInspectionRunway from '../assets/icons/tasks/task-inspection-runway.svg'
import TaskInspectionTaxiway from '../assets/icons/tasks/task-inspection-taxiway.svg'
import TaskInspectionTerminal from '../assets/icons/tasks/task-inspection-terminal.svg'
import TaskLvp from '../assets/icons/tasks/task-lvp.svg'
import TaskLvpOutline from '../assets/icons/tasks/task-lvp-outline.svg'
import TaskMaintenance from '../assets/icons/tasks/task-maintenance.svg'
import TaskMaintenanceBrushes from '../assets/icons/tasks/task-maintenance-brushes.svg'
import TaskMaintenanceGeneral from '../assets/icons/tasks/task-maintenance-general.svg'
import TaskMaintenanceSummer from '../assets/icons/tasks/task-maintenance-summer.svg'
import TaskMaintenanceWinter from '../assets/icons/tasks/task-maintenance-winter.svg'
import TaskProcessAutomatedVehicle from '../assets/icons/tasks/task-process-automated-vehicle-task.svg'
import TaskProcessDailyMaintenance from '../assets/icons/tasks/task-process-daily-maintenance.svg'
import TaskProcessDailyTerminal from '../assets/icons/tasks/task-process-daily-terminal.svg'
import TaskProcessSeasonal from '../assets/icons/tasks/task-process-seasonal-task.svg'
import TaskRecurrence from '../assets/icons/tasks/task-recurrence.svg'
import TaskRefuelling from '../assets/icons/tasks/task-refuelling.svg'
import TaskRescueService from '../assets/icons/tasks/task-rescue-service.svg'
import TaskSafetyInspection from '../assets/icons/tasks/task-safety-inspection.svg'
import Terminal from '../assets/icons/terminal.svg'
import Time from '../assets/icons/time.svg'
import Timeline from '../assets/icons/timeline.svg'
import Title from '../assets/icons/title.svg'
import ErrorToast from '../assets/icons/toast/error.svg'
import InfoToast from '../assets/icons/toast/info.svg'
import SuccessToast from '../assets/icons/toast/success.svg'
import WarningToast from '../assets/icons/toast/warning.svg'
import Transparent from '../assets/icons/transparent.svg'
import Type from '../assets/icons/type.svg'
import Undo from '../assets/icons/undo.svg'
import Unfold from '../assets/icons/unfold.svg'
import UserThumbnail from '../assets/icons/user-thumbnail.svg'
import Users from '../assets/icons/users.svg'
import Visibility from '../assets/icons/visibility.svg'
import VisibilityOff from '../assets/icons/visibility-off.svg'
import WarnSmall from '../assets/icons/warn-small.svg'
import WeatherAlert from '../assets/icons/weather_alert.svg'
import WeatherWarning from '../assets/icons/weather_warning.svg'
import ChartCbProbability from '../assets/icons/weather-items/charts/chart-cb-probability.svg'
import ChartCloudBase from '../assets/icons/weather-items/charts/chart-cloud-base.svg'
import ChartDewPoint from '../assets/icons/weather-items/charts/chart-dew-point.svg'
import ChartFwp from '../assets/icons/weather-items/charts/chart-fwp.svg'
import ChartFwpYellow from '../assets/icons/weather-items/charts/chart-fwp-yellow.svg'
import ChartLvp from '../assets/icons/weather-items/charts/chart-lvp.svg'
import ChartRain from '../assets/icons/weather-items/charts/chart-rain.svg'
import ChartRoadTemperature from '../assets/icons/weather-items/charts/chart-road-temperature.svg'
import ChartSnow from '../assets/icons/weather-items/charts/chart-snow.svg'
import ChartSnowRain from '../assets/icons/weather-items/charts/chart-snow-rain.svg'
import ChartTemperature from '../assets/icons/weather-items/charts/chart-temperature.svg'
import ChartTfwp from '../assets/icons/weather-items/charts/chart-tfwp.svg'
import ChartThunderstorm from '../assets/icons/weather-items/charts/chart-thunderstorm.svg'
import ChartTriangleDown from '../assets/icons/weather-items/charts/chart-triangle-down.svg'
import ChartTriangleUp from '../assets/icons/weather-items/charts/chart-triangle-up.svg'
import ChartWindDirection from '../assets/icons/weather-items/charts/chart-wind-direction.svg'
import ChartWindGusts from '../assets/icons/weather-items/charts/chart-wind-gusts.svg'
import ChartWindGusts12 from '../assets/icons/weather-items/charts/chart-wind-gusts-12.svg'
import ChartWindSpeed from '../assets/icons/weather-items/charts/chart-wind-speed.svg'
import Forecast from '../assets/icons/weather-items/forecast.svg'
import WeatherColdRoadTemperature from '../assets/icons/weather-items/weather-cold-road-temperature.svg'
import WeatherColdTemperature from '../assets/icons/weather-items/weather-cold-temperature.svg'
import WeatherFreezingWx from '../assets/icons/weather-items/weather-freezing-wx.svg'
import WeatherHeavyRain from '../assets/icons/weather-items/weather-heavy-rain.svg'
import WeatherHeavySnow from '../assets/icons/weather-items/weather-heavy-snow.svg'
import WeatherHotRoadTemperature from '../assets/icons/weather-items/weather-hot-road-temperature.svg'
import WeatherHotTemperature from '../assets/icons/weather-items/weather-hot-temperature.svg'
import WeatherLightingProbability from '../assets/icons/weather-items/weather-lighting-probability.svg'
import WeatherLightning from '../assets/icons/weather-items/weather-lightning.svg'
import WeatherLvp from '../assets/icons/weather-items/weather-lvp.svg'
import WeatherLvpPlain from '../assets/icons/weather-items/weather-lvp-plain.svg'
import WeatherNormal from '../assets/icons/weather-items/weather-normal.svg'
import WeatherRain from '../assets/icons/weather-items/weather-rain.svg'
import WeatherRoadTemperature from '../assets/icons/weather-items/weather-road-temperature.svg'
import WeatherSnow from '../assets/icons/weather-items/weather-snow.svg'
import WeatherSnowRain from '../assets/icons/weather-items/weather-snow-rain.svg'
import WeatherStrongWind from '../assets/icons/weather-items/weather-strong-wind.svg'
import WeatherTemperature from '../assets/icons/weather-items/weather-temperature.svg'
import WeatherThunderstormProb from '../assets/icons/weather-items/weather-thunderstorm-prob.svg'
import WeatherWindDirection from '../assets/icons/weather-items/weather-wind-direction.svg'
import WeatherWindGusts from '../assets/icons/weather-items/weather-wind-gusts.svg'
import WeatherWindSpeed from '../assets/icons/weather-items/weather-wind-speed.svg'
import WindScale from '../assets/icons/weather-items/wind-scale.svg'
import WeatherNotice from '../assets/icons/weather-notice.svg'
import Window from '../assets/icons/window.svg'
import WorldGrey from '../assets/icons/world-grey.svg'
import Yellow from '../assets/icons/yellow.svg'
import ZoomIn from '../assets/icons/zoom-in.svg'
import ZoomOut from '../assets/icons/zoom-out.svg'

/**
 * Base icon registry - all icons available to all customers
 */
export const baseIcons = {
    // Core icons
    FatArrowRight,
    ATCTower,
    NOTAM,
    SNOWTAM,
    Filter,
    DangerousGoods,
    AddPhoto,
    Fullscreen,
    Policy,
    Note,
    Firefighters,
    ShiftNote,
    EquipmentMaintenance,
    LoadReception,
    TaskOther,
    Refuelling,
    RegularInspection,
    TakingSamples,
    Supervision,
    TaskAnimalBanishment,
    TaskAnimalConfirmation,
    TaskAnimalKill,
    TaskAnimalObservation,
    TaskAnimals,
    TaskDeicing,
    Camera,
    TaskHba,
    TaskInspectionAreaInspection,
    Play,
    Pause,
    TaskInspectionContractor,
    PrivateInvitation,
    TaskInspectionFireTruck,
    TaskInspectionFod,
    TaskInspectionOther,
    TaskInspectionOtherActors,
    TaskInspectionOtherAreas,
    TaskInspectionRope,
    TaskInspectionRunway,
    TaskInspectionTaxiway,
    Phone,
    TaskInspectionTerminal,
    FlightInfo,
    TaskLvp,
    TaskLvpOutline,
    TaskMaintenance,
    TaskMaintenanceBrushes,
    TaskMaintenanceGeneral,
    TaskMaintenanceSummer,
    TaskMaintenanceWinter,
    TaskRefuelling,
    TaskRescueService,
    Billable,
    ArrowRightThin,
    TaskSafetyInspection,
    TaskProcessAutomatedVehicle,
    TaskProcessDailyMaintenance,
    TaskProcessDailyTerminal,
    TaskProcessSeasonal,
    TaskRecurrence,
    AutomaticFeed,
    CheckCircle,
    CheckCircleFilled,
    ContactList,
    InfoManagement,
    InfoCircle,
    Lightning,
    FlagDay,
    CUSSParkingMeters,
    CheckboxDone,
    Source,
    FlightChecks,
    HeatingWires,
    Route,
    Fuel,
    Plus,
    Terminal,
    Collapse,
    NotificationsEmpty,
    CheckboxIndeterminateDark,
    DeleteRound,
    Delete,
    Expand,
    Arrow,
    ArrowHead,
    ArrowDownward,
    ArrowRightBig,
    ArrowUpward,
    Assignment,
    AssignmentStar,
    Atc,
    Back,
    Burger,
    ChannelMail,
    ChannelNotification,
    ChannelPush,
    AirportGate,
    ChannelSms,
    Check,
    CheckboxEmpty,
    CheckboxEmptyDisabled,
    CheckboxGreenDone,
    CheckboxWhite,
    CheckboxCheckedLight,
    Checklist,
    ChecklistItem,
    ChevronRight,
    Chevron,
    CloseEvent,
    Close,
    NoPhotos,
    Compass,
    ConditionalIndicator,
    ConfigureNotifications,
    Content,
    CreateTask,
    CurrentTime,
    Dashboard,
    Datapicker,
    Delay,
    Departures,
    Description,
    DismissNotification,
    Done,
    DraggingHandle,
    Drop,
    AircraftTable,
    Asset,
    Bag,
    GatePark,
    Green,
    Grey,
    Handling,
    LocationUnderline,
    OkSmall,
    Orange,
    Park,
    Red,
    Undo,
    WarnSmall,
    Yellow,
    Copy,
    Edit,
    EmptyList,
    Emergency,
    Events,
    ExportChecklistTemplates,
    FeedOutConfirmation,
    Flights,
    Invalid,
    Place,
    Sorting,
    Subscriptions,
    Title,
    Transparent,
    Type,
    VisibilityOff,
    Fold,
    Car,
    Chemicals,
    Contractors,
    Fireman,
    Jobs,
    Road,
    Square,
    ForwardFat,
    Forward,
    Geolocation,
    InfoToast,
    SuccessToast,
    ErrorToast,
    WarningToast,
    Help,
    Hourglass,
    Images,
    Invitation,
    Layers,
    Location,
    LogOut,
    Mail,
    TrainDirection,
    TrainInner,
    TrainNoDirection,
    TrainNumber,
    Map,
    Message,
    MessageTriangle,
    Messaging,
    More,
    MoreInfo,
    NoData,
    NoForecast,
    NoEvents,
    NoMessages,
    NoTasks,
    NotAllowed,
    AddImages,
    Notifications,
    Notify,
    OpenIn,
    OutdatedApp,
    OperationalForecastBags,
    OperationalForecastNetwork,
    OperationalForecastPassengers,
    OperationalForecastTurnaround,
    OperationalForecastTerminal,
    OperationalForecastAirside,
    OtherRed,
    PickLocation,
    ParkingCarReturn,
    ParkingP,
    ParkingP1,
    ParkingP2,
    ParkingP3,
    ParkingP3Pika,
    ParkingP3Premium,
    ParkingP4A,
    ParkingP4B,
    ParkingP5,
    ParkingP6,
    ParkingP8,
    ParticipantAtAirport,
    ParticipantComing,
    ParticipantCommand,
    ParticipantObserving,
    ParticipantPending,
    ParticipantLeft,
    ParticipantRemote,
    Percent,
    Plane,
    PlaneStanding,
    TravelServicesArrivalServices,
    TravelServicesBaggageClaim1,
    TravelServicesBaggageClaim2A,
    TravelServicesBaggageClaim2B,
    TravelServicesCheckInDesks101114,
    TravelServicesCheckInDesks201218,
    TravelServicesCheckInDesks219232,
    TravelServicesCheckInDesks240270,
    TravelServicesCheckInKiosk,
    TravelServicesCustoms,
    TravelServicesPassportControl,
    TravelServicesSecurityCheck,
    WalkingRouteMarker,
    Pictures,
    Pin,
    Pinned,
    ArrivalsPlaceholder,
    ChecklistPlaceholder,
    CreateMessageTemplatePlaceholder,
    CreateTaskPlaceholder,
    DeparturesPlaceholder,
    InspectorPlaceholder,
    InvitePlaceholder,
    MessagePlaceholder,
    MessageTemplatePlaceholder,
    UnitPlaceholder,
    UserGroupPlaceholder,
    UserPlaceholder,
    PrivateClosed,
    Private,
    RestoreUser,
    AddUser,
    RotateLeft,
    RotateRight,
    Save,
    Schedule,
    SearchFilters,
    Search,
    SelectItem,
    Send,
    SendAlert,
    Settings,
    Share,
    ShowLess,
    ShowMore,
    Spinner,
    Star,
    StatusReport,
    Storage,
    Error,
    Success,
    WarningBold,
    Warning,
    Target,
    Task,
    Time,
    Timeline,
    Unfold,
    UserThumbnail,
    Users,
    Visibility,
    ChartCbProbability,
    ChartCloudBase,
    ChartDewPoint,
    ChartFwp,
    ChartFwpYellow,
    ChartLvp,
    ChartRain,
    ChartRoadTemperature,
    ChartSnowRain,
    ChartSnow,
    ChartTemperature,
    ChartTfwp,
    ChartThunderstorm,
    ChartTriangleDown,
    ChartTriangleUp,
    ChartWindDirection,
    ChartWindGusts12,
    ChartWindGusts,
    ChartWindSpeed,
    WeatherColdRoadTemperature,
    WeatherColdTemperature,
    WeatherFreezingWx,
    WeatherHeavyRain,
    WeatherHeavySnow,
    WeatherHotRoadTemperature,
    WeatherHotTemperature,
    WeatherLightingProbability,
    WeatherLightning,
    WeatherLvp,
    WeatherLvpPlain,
    WeatherNormal,
    WeatherRoadTemperature,
    WeatherRain,
    WeatherSnowRain,
    WeatherSnow,
    WeatherStrongWind,
    WeatherTemperature,
    WeatherThunderstormProb,
    WeatherWindDirection,
    WeatherWindGusts,
    WeatherWindSpeed,
    Forecast,
    WindScale,
    Window,
    WorldGrey,
    Default,
    ZoomIn,
    ZoomOut,
    CheckboxChecked,
    CheckboxIndeterminate,
    RadioChecked,
    RadioCheckedDisabled,
    RadioEmpty,
    RadioEmptyDisabled,
    Gas,
    MarkReview,
    StatusAtAirport,
    StatusComing,
    StatusRemote,
    Attachment,
    Download,
    WeatherAlert,
    WeatherNotice,
    WeatherWarning,
    Recent,
    Report,
    Pax,
    // Shared scenario icons
    AirlineGroundHandling,
    TurnaroundGeneralInfo,
    Info,
    World,
    NetworkIt,
    NetworkGeneral,
    NetworkWeather,
    NetworkWorld,
    // Tenant-agnostic scenario icons referenced by name from feature code rather than from
    // config, so they must resolve without a customer registry. Byte-identical in the aos and
    // aoims registries, which still shadow these until the compiled tenant path is retired.
    AircraftStands,
    Roads,
    SafetySecurity,
    Snow,
    Train,
    // Base takes the AOS variants deliberately: SWEDAVIA aliases the AOS registry
    // (customers/index.ts), so these are the drawings it renders today and base has to keep
    // rendering them once that aliasing goes. AOIMS draws both differently and carries its own
    // in its icons map.
    Arrivals,
    Gate,
}
